import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/dist/query/react';
import { catchResponse, prepareFetchRequest } from '../common.service';
import { ICards, IResCards } from '../response.interface';
import { RequestFetchCardListByHolderOrAccount } from './model/request';

export const cardListAPI = createApi({
  reducerPath: 'cardListAPI',
  baseQuery: fetchBaseQuery(prepareFetchRequest()),
  tagTypes: ['oneCards'],
  endpoints: (build) => ({
    fetchCardListByHolderOrAccount: build.query<IResCards, RequestFetchCardListByHolderOrAccount>({
      async queryFn({ locale, holderId, accountId }, { getState, dispatch }, extraOptions, fetchWithBQ) {

        /* Проверяем какие данные для запроса списка карт переданы */
        let result: any;
        /* Если есть аккаунт запрашивать данные карт по нему */
        if (accountId && accountId !== 0) {
          result = await fetchWithBQ({ url: `/accounts/${accountId}/cards`, params: { lang: locale } });
        }

        if (holderId && holderId !== 0 && accountId === 0) {
          result = await fetchWithBQ({ url: `/holders/${holderId}/cards`, params: { lang: locale } });
        }

        result && catchResponse({
          data: result.data, meta: result.meta, getState, dispatch,
        });

        const data = result && result.data as IResCards;

        data.cards = data && data.cards && data.cards.map((card: ICards) => {
          return {
            ...card,
            fio: `${card.cardInfo?.lastName || ''} ${card.cardInfo?.firstName || ''}`,
            cardStatus: card.status === 0,
            firstName: card.cardInfo?.firstName || '',
            lastName: card.cardInfo?.lastName || '',
            mobile: card.cardInfo?.mobile || '',
            email: card.cardInfo?.email || '',
          };
        });

        return { data };

      },
    }),
  }),
});
